<template>
  <template-recovery>
    <template #banner>
      <img
        src="~@/assets/images/banners/user_card.svg"
        alt="Esqueci meu registro"
      />
      <p><i class="icon-ic_alert-blue" />{{ $t('recuperar-registro.info') }}</p>
    </template>
    <template #contentHeader>
      <h2>{{ $t('recuperar-registro.title') }}</h2>
      <h3>
        {{ $t('recuperar-registro.subtitle') }}
      </h3>
    </template>
    <template #content>
      <div class="reset-password">
        <div class="cards-container">
          <div class="card-form">
            <form class="form-template">
              <div class="block">
                <b-radio
                  v-for="contato in contatos"
                  :key="contato.type"
                  type="is-info"
                  class="radios"
                  @input="handleData"
                  :native-value="contato.type"
                  v-model="tipoContato"
                  required
                >
                  {{ contato.texto }}
                </b-radio>
              </div>
              <div class="field" v-show="tipoContato == 'email'">
                <b-field>
                  <b-input
                    v-model.lazy="email"
                    name="email"
                    type="email"
                    :placeholder="`${$t('placeholders.email')}`"
                  />
                </b-field>
                <div class="link-reset">&nbsp;</div>
              </div>
              <div class="field" v-show="tipoContato == 'telefone'">
                <b-field>
                  <b-input
                    v-model.lazy="telefone"
                    name="telefone"
                    v-mask="['(##) ####-####', '(##) #####-####']"
                    :placeholder="`${$t('placeholders.phone')}`"
                  />
                </b-field>
                <div class="link-reset">&nbsp;</div>
              </div>
              <div class="field" v-show="tipoContato == 'cpf'">
                <b-field>
                  <b-input
                    v-model.lazy="cpf"
                    name="cpf"
                    v-mask="['###.###.###-##']"
                    :placeholder="`${$t('placeholders.cpf')}`"
                  />
                </b-field>
                <div class="link-reset">&nbsp;</div>
              </div>
              <div class="columns">
                <div class="column">
                  <div class="field">
                    <button
                      :disabled="disabledButton"
                      class="button button-primary"
                      type="submit"
                      @click.prevent="() => recuperarRegistroAction()"
                    >
                      {{ $t('login.confirm_button') }}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <modal-template v-if="showModal" class="override-modal">
          <template #header>
            <h2>{{ modalText.titulo }}</h2>
          </template>
          <template #body>
            <p>{{ modalText.subtitulo }}</p>
          </template>
          <template #footer>
            <button
              id="loginmodal"
              class="button button-primary"
              @click="toggleInfoModal"
            >
              {{ modalText.btnTexto }}
            </button>
          </template>
        </modal-template>
        <modal-template v-if="showContatos">
          <template #header>
            <h2>{{ modalText.titulo }}</h2>
          </template>
          <template #body>
            <p class="is-centered" v-if="!contatosPaciente?.length">
              {{ $t('recuperar-registro.nenhum-contato') }}
            </p>
            <p class="is-centered" v-else>
              {{ modalText.subtitulo }}
            </p>
            <div class="reset-password">
              <div class="cards-container-centered">
                <div class="centered-content">
                  <card-item
                    v-for="contato in contatosPaciente"
                    :key="contato.Contato"
                    :titulo="
                      contato.Tipo === 'E'
                        ? $t('recuperar-registro.por-email')
                        : $t('recuperar-registro.por-celular')
                    "
                    :descricao="`Termina em ${contato.Contato}`"
                    @aoClicarCard="() => recuperarRegistroContato(contato)"
                  />
                </div>
              </div>
            </div>
          </template>
          <template #footer>
            <button
              id="loginmodal"
              class="button button-primary"
              @click="showContatos = !showContatos"
            >
              {{ modalText.btnTexto }}
            </button>
          </template>
        </modal-template>
      </div>
    </template>
  </template-recovery>
</template>

<script>
import TemplateRecovery from '@/components/recovery/TemplateRecovery'
import ModalTemplate from '@/components/shared/modal/ModalTemplate'
import { mapActions, mapGetters } from 'vuex'
import CardItem from '@/components/shared/cards/CardItem'
import { validateCPF } from '../../mixins/cpf-validator'
import { validateEmail } from '../../mixins/email-validator'

export default {
  components: {
    ModalTemplate,
    CardItem,
    TemplateRecovery
  },
  data() {
    return {
      contatos: [
        {
          type: 'email',
          texto: 'E-mail',
          mask: '^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$',
          placeholder: this.$t('placeholders.email')
        },
        {
          type: 'telefone',
          texto: 'Telefone',
          mask: '["(##) ####-####", "(##) #####-####"]',
          placeholder: this.$t('placeholders.phone')
        },
        {
          type: 'cpf',
          texto: 'CPF',
          mask: '["###.###.###-##"]',
          placeholder: this.$t('placeholders.cpf')
        }
      ],
      contatoSelecionado: {
        type: 'email',
        texto: 'E-mail',
        mask: '',
        placeholder: this.$t('placeholders.email')
      },
      tipoContato: 'email',
      enviarPara: '',
      maskTelefone: ['(##) ####-####', '(##) #####-####'],
      contatosPaciente: [],
      email: '',
      telefone: '',
      cpf: '',
      showModal: false,
      showContatos: false,
      modalText: {
        titulo: '',
        subtitulo: '',
        btnTexto: '',
        redirecionarInicio: true
      }
    }
  },
  computed: {
    ...mapGetters({
      allContacts: 'allContacts',
      isLoading: 'isLoading'
    }),
    disabledButton() {
      if (this.tipoContato === 'cpf') {
        return !validateCPF(this.cpf)
      }

      if (this.tipoContato === 'telefone') {
        return this.telefone.length < 10
      }

      return !validateEmail(this.email)
    },
    ehEmail() {
      return this.email.length > 5
    }
  },
  methods: {
    ...mapActions(['recuperarRegistro', 'contatosCpf']),
    toggleInfoModal() {
      this.showModal = !this.showModal
      if (this.modalText.redirecionarInicio) {
        this.$router.push('/')
      }
    },
    returnHome() {
      this.$router.push('/')
    },
    handleData() {
      var id = this.contatos.find((x) => x.type === this.tipoContato)

      this.telefone = this.tipoContato === 'telefone' ? this.telefone : ''
      this.cpf = this.tipoContato === 'cpf' ? this.cpf : ''
      this.email = this.tipoContato === 'email' ? this.email : ''

      if (id != null) {
        this.contatoSelecionado.type = id.type
        this.contatoSelecionado.mask = id.mask
        this.contatoSelecionado.placeholder = id.placeholder
        this.contatoSelecionado.texto = id.texto
      }
    },
    async recuperarRegistroContato(contato) {
      this.tipoContato = contato.Tipo === 'E' ? 'email' : 'telefone'
      let cpf = this.cpf
      this.handleData()
      this.cpf = cpf
      await this.recuperarRegistroAction(contato.Contato)

      this.showContatos = false
    },
    async recuperarRegistroAction(emailOuTelefone) {
      if (this.tipoContato === 'cpf') {
        this.contatosCpf(this.cpf.replace(/\D+/gi, '')).then(
          (contatosPaciente) => {
            this.contatosPaciente = contatosPaciente

            this.modalText = {
              titulo: this.$t('recuperar-registro.subtitle'),
              subtitulo: this.$t('recuperar-registro.subtitle-choose'),
              btnTexto: this.$t('botoes.sair'),
              redirecionarInicio: false
            }

            this.showContatos = true
          }
        )
        return
      }
      const emailTelefone =
        emailOuTelefone ?? this[this.contatoSelecionado.type]
      console.log(emailTelefone)
      const cpf = this.cpf?.replace(/\D+/gi, '')
      await this.recuperarRegistro({ emailTelefone, cpf })
        .then(() => {
          if (this.ehEmail) {
            this.modalText = {
              titulo: this.$t('recuperar-registro.email.titulo'),
              subtitulo: this.$t('recuperar-registro.email.subtitulo'),
              btnTexto: this.$t('botoes.confirmar'),
              redirecionarInicio: true
            }
          } else {
            this.modalText = {
              titulo: this.$t('recuperar-registro.telefone.titulo'),
              subtitulo: this.$t('recuperar-registro.telefone.subtitulo'),
              btnTexto: this.$t('botoes.confirmar'),
              redirecionarInicio: true
            }
          }
          this.showModal = !this.showModal
        })
        .catch((error) => {
          this.modalText = {
            titulo: this.$t('erro.padrao.titulo'),
            subtitulo: this.$t('erro.padrao.subtitulo') + '\n' + error.message,
            btnTexto: this.$t('botoes.confirmar'),
            redirecionarInicio: false
          }
          this.showModal = !this.showModal
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/base';

.recovery-content {
  .img-container {
    p {
      font-size: 0.875rem;

      color: var(--gray-700);
      text-align: center;
      i {
        padding-right: 0.3125rem;
        &:before {
          font-size: 1.5rem;
          position: relative;
          top: 0.3125rem;
        }
      }
    }
  }
  .cards-container {
    margin-top: 1.875rem;
  }
  .cards-container-centered {
    display: flex;
    justify-content: center; /* Alinha horizontalmente */
    align-items: center; /* Alinha verticalmente */
  }

  .card-form {
    max-width: 22.125rem;
  }
}
.state-container {
  padding-top: 12rem;
}
@media (min-width: 768px) {
  .state-container {
    max-height: 100%;
    padding-right: 3rem;
    padding-left: 3rem;
  }
}
@import '~@/assets/stylesheets/base';
.button[type='submit'] {
  display: block;
  max-width: 100%;
  margin-top: 0;
  text-align: center;
}
.link-reset {
  margin-bottom: 1.8rem;
}
</style>
